import * as React from 'react';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { LoginFormValues } from '../../components/LoginForm/useLoginForm';
import LangEnum from '../../lang/LangEnum';
import snackbarStore from '../../stores/Snackbar.store';
import { Team } from '../context/ApplicationContext/applicationContext.types';
import { useTranslation } from '../translation/TranslationContext';
import { useAuthContext } from './AuthContext';
import CreateAccountModal from './CreateAccountModal';
import ActivationLoginModal from './components/ActivationLogin/ActivationLoginModal';
import LoginPanel from './components/LoginPanel/LoginPanel';
import SsoLoginChoice from './components/SsoLoginChoice/SsoLoginChoice';
import TeamSelectModal from './components/TeamSelectModal/TeamSelectModal';
import UserSelectModal from './components/UserSelectModal/UserSelectModal';
import { LoginCredentials, useAuthLogin } from './hook/useAuthLogin';

export type UserLogin = {
  user?: {
    id: string;
    access_token: string;
    ok: boolean;
    name: string;
    email: string;
    surname: string;
  };
  teams: Array<Team>;
};

const Login: React.FC = () => {
  const {
    doLogin,
    setOpenTeamModal,
    openTeamModal,
    handleSelectTeam,
    handleSelectPersonatedUser,
    userInfo,
    openUsersModal,
    setOpenUsersModal,
    openActivationModal,
    setOpenActivationModal,
  } = useAuthLogin();
  const { loginContext, logout } = useAuthContext();
  const history = useHistory();
  const { translate } = useTranslation();

  const { handleMessage } = snackbarStore;

  const [openCreateAccountModal, setOpenCreateAccountModal] = useState(false);
  const [hasChosenEmailLogin, setHasChosenEmailLogin] = useState(false);

  const afterFirstAccessSubmit = async () => {
    setOpenActivationModal(false);
    await logout({ keepLoginContext: true });
    handleMessage({ type: 'info', message: translate(LangEnum.LOGIN_WARNING_CHANGED_DATA) });
  };

  const handleLoginSubmit = async (values: LoginFormValues) => {
    const credentials: LoginCredentials = { username: values.email, password: values.password };
    await doLogin(credentials);
  };

  const handleCreateStore = () => {
    history.push(`${loginContext?.slug}/store-sign-up`);
  };

  const baseUrl = loginContext?.slug ? `/${loginContext?.slug}` : '';
  const isSsoChoiceVisible = !!loginContext?.hasFederatedLogin && !hasChosenEmailLogin;

  return (
    <>
      <ActivationLoginModal
        isOpen={openActivationModal}
        onClose={() => setOpenActivationModal(false)}
        afterSubmit={afterFirstAccessSubmit}
      />
      <TeamSelectModal
        title={LangEnum.TEAM_MODAL_CHOOSE_TEAM_TITLE}
        open={openTeamModal}
        teams={userInfo.teams}
        onClick={handleSelectTeam}
        onClose={() => setOpenTeamModal(false)}
      />
      <UserSelectModal
        title={translate(LangEnum.TEAM_MODAL_GREETINGS_TEXT, { user: userInfo?.user?.name })}
        open={openUsersModal}
        onClose={() => setOpenUsersModal(false)}
        onClick={handleSelectPersonatedUser}
      />
      <CreateAccountModal
        open={openCreateAccountModal}
        onClose={() => setOpenCreateAccountModal(false)}
        onClickCreateStore={handleCreateStore}
      />
      {isSsoChoiceVisible && loginContext ? (
        <SsoLoginChoice
          brandSlug={loginContext.slug}
          baseUrl={baseUrl}
          onChooseEmail={() => setHasChosenEmailLogin(true)}
        />
      ) : (
        <LoginPanel baseUrl={baseUrl} onSubmit={handleLoginSubmit} />
      )}
    </>
  );
};

export default Login;
